export default __webpack_public_path__ + "static/media/birthday-announcement.76a7acee.webp";